module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 263
// module chunks = 168707334958949